<template>
  <div class="container page lottery">
    <van-nav-bar :title="lottery.name" class="nav-bar">
     <template #left>
        <van-icon name="arrow-left" color="#fff" @click="back()" />
      </template> 
         <template #right>
           <!-- <div class="right" @click="showRight">{{ $t('reservation.switching_window') }}</div> -->
       </template>
    </van-nav-bar>
    <div class="record">
      <div class="period">
        <van-image class="cover" :src="lottery.ico">
          <template v-slot:loading>
            <van-loading type="spinner" />
          </template>
        </van-image>
        <span class="period-number">No.{{ Number(lottery.now_expect)+1 }}</span>
        <div class="next-number">
          <!-- <span>{{this.lottery.next_expect}}</span> -->
          <van-count-down :time="time" @finish="check()" />
        </div>
      </div>
      <div
        class="linear-gradient"
        style="
          background: linear-gradient(
            to right,
            rgba(126, 86, 120, 0),
            rgb(230, 195, 161),
            rgba(126, 86, 120, 0)
          );
        "
      ></div>
      <div

        class="numberBox"
        style="
          background: rgb(244, 124, 213);
          padding: 12px;
          margin-bottom: 10px;
          border-radius: 8px;
          display: flex;
          align-items: center;
        "
      >
        <div

          style="
            border-right: 4px solid rgb(249, 177, 231);
            padding: 0px 30px 0px 10px;
            color: rgb(255, 255, 255);
            font-weight: bold;
            font-size: 16px;
            text-align: center;
          "
        >
          <div >{{ lottery.now_expect}}</div>
          <div >{{ $t('reservation.voting_results') }}</div>
        </div>
        <div  class="resBox">
          <!-- <div  class="resItem">{{ sum }}</div> -->
          <div >
            <div

              class="ressquareBox"
              style="margin: 0px 0px 5px; min-width: 140px;"
            >
              {{ size }}
            </div>
            <div  class="ressquareBox" style="margin: 0px;">
              {{double}}
            </div>
          </div>

          <van-icon name="arrow-down"  :class="{ up: active,down:!active }" @click="active ? active = false : active = true" style="margin-left: auto;" />
        </div>
      </div>

    </div>
    <div class="history_popup"></div>
    <div class="wrapper">
      <div class="options-bar">
        <div class="game">

          <div
            class="linear-gradient"
            style="
              background: linear-gradient(
                to right,
                rgba(126, 86, 120, 0),
                rgb(230, 195, 161),
                rgba(126, 86, 120, 0)
              );
            "
          ></div>
          <div class="sumValueTwoSides">
            <div
              class="rectangle large"
              :class="{ active: choose[v.type] }"
              v-for="(v, key) in lottery_peilv_list"
              :key="key"
              @click="choosePlay(v.type, v.name)"
            >

              <div class="wrapper">
                <div class="content">
                  <p class="name-text large">{{ v.name=='big'?rose:v.name=='small'?lily:v.name=='one'?fireworks:balloon }}</p>
                  <p class="odd-text large">{{ v.proportion }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="bottom-bar">

        <div class="wrapper" :class="{ active: shopping }">
          <div class="item">
            <span class="label">{{ $t("reservation.curr_choose") }}：</span>
            <div class="bet-number">{{ convertedShopchoose  }}</div>
            <van-icon
              name="arrow-down"
              :class="{ up: !shopping, down: shopping }"
              @click="shopping ? (shopping = false) : (shopping = true)"
            />
          </div>
          <div class="item">
            <span class="label">{{ $t("reservation.per_price") }}：</span>
            <div class="amount-wrapper">
              <van-field
                v-model="money"
                type="digit"
                :placeholder="$t('reservation.price_place')"
              />

            </div>
          </div>
          <div class="item">
            <span class="label">{{ $t("reservation.total") }}</span>
            <span class="count-number">{{ formData.length }}</span>
            <span class="bet-summary-name">きよみずでら</span>
            <span class="label">{{ $t("reservation.note") }}</span>
            <span class="count-number">{{ Number(money * formData.length) }}</span>
            <span class="label">{{ $t("reservation.hg") }}</span>
          </div>
          <div class="quick-bet jifenItemBox">
            <div
              class="quick-bet-item"
              :class="{ active: String(money) === String(item.value) }"
              v-for="item in quickBetAmounts"
              :key="item.value"
              @click="setQuickBetAmount(item.value)"
            >
              <span>{{ item.label }}</span>
            </div>
          </div>
        </div>
        <div class="bar">
          <div class="left">
            <div
                class="item"
                @click="shopping ? (shopping = false) : (shopping = true)"
            >
              <van-icon name="cart-o" class="jixuanico" />

            </div>
            <div class="line"></div>
          </div>
          <div class="mid">
            <span class="text" style="margin-right: 6px;">{{ $t("reservation.available_balance") }}:</span>
            <span class="text num">{{ this.userInfo.money }}</span>

          </div>
          <div class="right" @click="jiesuan()">
            {{ $t("reservation.submit") }}
          </div>
        </div>
      </div>
      <van-popup v-model="jiesuanpage" get-container="body">
        <div class="confirm-order-modal">
          <!-- <div class="head van-hairline--bottom">
            <p class="text">{{ $t("reservation.task_list") }}</p>
          </div> -->
          <ui class="list">
            <li
              v-for="(v, key) in formData"
              :key="key"
              class="lise-item van-hairline--bottom"
            >
              <div class="main">
                <p class="bet-name">{{ v.name=='big'?rose:v.name=='small'?lily:v.name=='one'?fireworks:balloon}}</p>
                <p class="detail-text">
                  1{{ $t("reservation.note") }}X{{ money
                  }}{{ $t("reservation.unit") }}={{ money
                  }}{{ $t("reservation.ge") }}
                </p>
              </div>
              <van-icon @click="clearChooes(v.type)" name="close" />
            </li>
          </ui>
          <div class="sub-bar">
            <van-button
              class="item cancel-btn"
              type="default"
              @click="allClear()"
              >{{ $t("reservation.clear_order") }}</van-button
            >
            <van-button class="item sub-btn" type="default" @click="doSub">{{
              $t("reservation.submit")
            }}</van-button>
          </div>
        </div>
      </van-popup>
      <van-popup v-model="active" position="top" :style="{ height: '70%' }">
        <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
          <div class="wrapper">
            <div class="item">
              <div class="left font-weight">{{ $t("reservation.num") }}</div>
              <div class="right font-weight">
                {{ $t("reservation.win_num") }}
              </div>
            </div>
            <div class="item" v-for="(v, key) in lottery_list" :key="key">
              <div class="left font-weight">{{ v.expect }}</div>
              <div class="right font-weight">
                <div class="kuaisan-ball left">
                  <span class="middle">{{ getRoseLily(v.opencode[0] + v.opencode[1] + v.opencode[2]) }}</span>
                  <span class=" middle">{{
                    (v.opencode[0] + v.opencode[1] + v.opencode[2]) % 2 === 0
                      ? balloon
                      : fireworks
                  }}</span>
                </div>
              </div>
            </div>
          </div>
        </van-pull-refresh>
      </van-popup>

    </div>
    <van-popup v-model="showModel" position="right" :style="{ width: '70%',height:'100%' }">
       <div class="list">

          <div class="item" v-for="(i,index) in gameitemData" :key="index" @click="tabList(i.id,i.key)">
              <div>연결 활동</div>
              <div style="margin: 15px 0 0 15px;">
                <div style="height: 86px;background-color: #fff;width: 60px;display: flex;align-items: center;border-radius: 8px;">
                  <van-image
  width="60"
  height="61"
  :src="i.ico"
  style=""
/>
                </div>

<div style="font-size: 14px;">{{ i.name }}</div>
              </div>
            </div>


       </div>
      </van-popup>
  </div>
</template>

<script>
var time;
var count = 0;
export default {
  data() {
    return {
      jiesuanpage: false,
      showModel: false,
      rose: '',
      lily: '',
      balloon: "",
      fireworks:"",
      choose: {
        big: false,
        small: false,
        one: false,
        two: false,
        "3": false,
        "4": false,
        "5": false,
        "6": false,
        "7": false,
        "8": false,
        "9": false,
        "10": false,
        "11": false,
        "12": false,
        "13": false,
        "14": false,
        "15": false,
        "16": false,
        "17": false,
        "18": false,
      },
      playgame: false,
      shopping: false,
      isLoading: false,
      play: {},
      lottery_peilv_list: {},
      lottery_list: {},
      active: false,
      userInfo: {},
      lottery: {},
      shanzi_1: "0",
      shanzi_2: "0",
      shanzi_3: "0",
      sum: 0,
      size: "",
      double: "",
      time: 0,
      shopchoose: this.$t("reservation.no_choose"),
      gameitem: "",
      formData: [],
      money: "",
      quickBetAmounts: [
        { label: "20", value: "20" },
        { label: "100", value: "100" },
        { label: "500", value: "500" },
        { label: "1K", value: "1000" },
        { label: "2.5K", value: "2500" },
        { label: "5K", value: "5000" },
      ],
      ids: 11,
      keys: 5,
      gameitemData: [],
    };
  },
  methods: {
    back() {
      return window.history.back();
    },
    setQuickBetAmount(value) {
      this.money = String(value);
    },
    getRoseLily(sum) {
      if (sum >= 11 && sum <= 18) {
        return this.rose;
      }
      return this.lily;
    },
    doSub() {
      if (this.money === "0") {
        this.$toast(this.$t("reservation.money_err"));
        return false;
      }
      if (this.formData.length === 0) {
        this.$toast(this.$t("reservation.choose_num"));
        return false;
      } else if (this.money === "") {
        this.$toast(this.$t("reservation.price_place"));
        return false;
      } else {
        if (this.userInfo.money - this.money * this.formData.length < 0) {
          this.$toast(this.$t("reservation.balance_enough"));
          return false;
        } else {
          this.$http({
            method: "post",
            data: {
              item: this.gameitem,
              money: this.money,
              lid: this.lottery.id,
              mid: this.userInfo.id,
              expect: this.lottery.now_expect,
            },
            url: "game_place_order",
          }).then((res) => {
            if (res.code === 200) {
              this.$toast(res.msg);
              this.allClear();
              this.getUserInfo();
            } else if (res.code === 401) {
              this.$toast(res.msg);
            }
          });
          return true;
        }
      }
    },
    allClear() {
      for (var i = 0; i < this.formData.length; i++) {
        this.choose[this.formData[i]["type"]] = false;
      }
      this.formData.length = 0;
      this.money = "";
      this.shopchoose = this.$t("reservation.no_choose");
      this.gameitem = "";
      this.shopping = false;
      this.jiesuanpage = false;
    },
    showRight() {
      this.showModel = true;
    },
    jiesuan() {
      if (this.formData.length === 0) {
        this.$toast(this.$t("reservation.choose_num"));
        return false;
      } else if (this.money === "") {
        this.$toast(this.$t("reservation.price_place"));
        return false;
      } else {
        this.jiesuanpage
          ? (this.jiesuanpage = false)
          : (this.jiesuanpage = true);
      }
    },
    clearChooes(type) {

      for (var i = 0; i < this.formData.length; i++) {
        if (type === this.formData[i]["type"]) {
          this.formData.splice(i, 1);
          this.choose[type] = false;
        }
      }
      if (this.formData.length >= 1) {
        for (var j = 0; j < this.formData.length; j++) {
          if (j === 0) {
            this.shopchoose = this.formData[j]["name"];
            this.gameitem = this.formData[j]["type"];
          } else {
            this.shopchoose += "," + this.formData[j]["name"];
            this.gameitem += "," + this.formData[j]["type"];
          }
        }
      } else {
        this.shopchoose = this.$t("reservation.no_choose");
        this.gameitem = "";
        this.shopping = false;
      }
      if (this.formData.length === 0) {
        this.jiesuanpage = false;
      }
    },
    choosePlay(type, name) {
      console.log(type, name);
      console.log(this.choose)
      if (this.choose[type] === true) {
        this.choose[type] = false;
        for (var i = 0; i < this.formData.length; i++) {
          if (type === this.formData[i]["type"]) {
            this.formData.splice(i, 1);
          }
        }
      } else if (this.choose[type] === false) {
        this.formData.push({ name: name, type: type });
        this.choose[type] = true;
      }
      if (this.formData.length === 1) {
        this.shopping = true;
      }
      if (this.formData.length >= 1) {
        for (var j = 0; j < this.formData.length; j++) {
          if (j === 0) {
            this.shopchoose = this.formData[j]["name"];
            this.gameitem = this.formData[j]["type"];
          } else {
            this.shopchoose += "," + this.formData[j]["name"];
            this.gameitem += "," + this.formData[j]["type"];
          }
        }
        console.log(this.shopchoose, 'ssss')

      } else {
        this.shopchoose = this.$t("reservation.no_choose");
        this.gameitem = "";
        this.shopping = false;
      }
    },
    check() {
      if (!localStorage.getItem("token")) {
        this.$router.push({ path: "/Login" });
      } else {
        time = window.setInterval(() => {
          setTimeout(() => {
            this.getUserInfo();
            this.getLotteryInfo();
            this.getLotteryList();
            count++;
            if (count > 5) {
              clearInterval(time);
              count = 0;
            }
          }, 0);
        }, 300);
      }
    },
    onRefresh() {
      setTimeout(() => {
        this.$toast(this.$t("reservation.refresh"));
        this.getLotteryList();
        this.isLoading = false;
      }, 200);
    },
    getUserInfo() {
      this.$http({
        method: "get",
        url: "user_info",
      }).then((res) => {
        if (res.code === 200) {
          this.userInfo = res.data;
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
    getLotteryPeilv() {
      this.$http({
        method: "get",
        data: { id:this.ids },
        url: "lottery_get_peilv",
      }).then((res) => {
        if (res.code === 200) {
          this.lottery_peilv_list = res.data;
          console.log("lottery_peilv_list:",this.lottery_peilv_list);

        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
    getLotteryList() {
      this.$http({
        method: "get",
        data: { key: this.keys },
        url: "lottery_get_one_list",
      }).then((res) => {
        if (res.code === 200) {
          this.lottery_list = res.data;
          console.log("lottery_list:");
          console.log(res.data);
          this.getLotteryPeilv();
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
    getGameItem(){
      this.$http({
        method: 'get',
        url: 'lottery_list'
      }).then(res=>{
        this.gameitemData = res.data;
        console.log(this.gameitemData,'gameitemData')
      })
    },
    tabList(id,key) {
      console.log(id,key)
      this.ids = id
      this.keys = key
      this.showModel = false
      this.getUserInfo();
      this.getGameItem()
      this.getLotteryInfo();
      this.getLotteryList();
    },
    getLotteryInfo() {
      this.$http({
        method: "get",
        data: { key: this.keys },
        url: "lottery_get_info",
      }).then((res) => {
        const lanng = localStorage.getItem("lang");
        if (res.code === 200) {
          if (
            parseFloat(this.userInfo.money) < parseFloat(res.data.condition)
          ) {
            this.$toast(this.$t("reservation.contact_admin"));
            this.$router.push({ path: "/Home" });
            return false;
          }
          this.lottery = res.data;
           console.log(this.lottery,'qweqweqw')
          this.time = res.data.second * 1000;

          if (this.time / 1000 === 59) {
            this.$toast(
              this.$t("reservation.prize_succ") + this.lottery.now_expect
            );
          }

          this.sum =
            res.data.opencode[0] + res.data.opencode[1] + res.data.opencode[2];
             console.log(this.sum,'sum')
          // if (this.sum >= 11 && this.sum <= 18) {
          //   lanng == 'zh'? this.size = '玫瑰':lanng == 'en'? this.size = 'Rose':lanng == 'ja'? this.size = 'バラは':this.size = '장미'

          // } else if (this.sum >= 3 && this.sum <= 10) {
          //     lanng == 'zh'? this.size = '百合':lanng == 'en'? this.size = 'Lily':lanng == 'ja'? this.size = "リリー·リリー":this.size = '백합'
          // }
          // if (this.sum % 2 === 0) {
          //    lanng == 'zh'? this.double = "氣球":lanng == 'en'? this.double = "Balloon":lanng == 'ja'? this.double = "气球":this.double = "풍선";

          // } else {
          //   lanng == 'zh'? this.double = "煙花":lanng == 'en'? this.double = "fireworks":lanng == 'ja'? this.double = "花火大会":
          //     this.double = "불꽃놀이";
          // }
          if (this.sum >= 11 && this.sum <= 18) {
            lanng == 'zh' ? this.size = '富士山' : lanng == 'en' ? this.size = 'Mount Fuji' : lanng == 'ko' ? this.size = '후지산' : this.size = 'ふじさん'
          } else if (this.sum >= 3 && this.sum <= 10) {
            lanng == 'zh' ? this.size = '战争' : lanng == 'en' ? this.size = 'War' : lanng == 'ko' ? this.size = '전쟁' : this.size = "せんそうじ"
          }
          if (this.sum % 2 === 0) {
            lanng == 'zh' ? this.double = "清水寺" : lanng == 'en' ? this.double = "KiyomizuTemple" : lanng == 'ko' ? this.double = "청수사" : this.double = "きよみずでら";
          } else {
            lanng == 'zh' ? this.double = "姬路城" : lanng == 'en' ? this.double = "Himeji Castle" : lanng == 'ko' ? this.double = "히메지 성" : this.double = "ひめじじょう";
          }
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
        console.log(this.lottery,9900)
      });
    },
  },
  created() {
    if (!localStorage.getItem("token")) {
      this.$router.push({ path: "/Login" });
    } else {
      this.ids = this.$route.query.id;
      this.keys = this.$route.query.key;
      this.getUserInfo();
      this.getGameItem()
      this.getLotteryInfo();
      this.getLotteryList();
    }
    const lang = localStorage.getItem("lang");
    if (lang == 'zh') {
      this.rose = '富士山';
      this.lily = '战争';
      this.balloon = '清水寺'
      this.fireworks='姬路城'
    } else if (lang == 'en') {
      this.rose = 'Mount Fuji';
      this.lily = 'War';
      this.balloon = 'KiyomizuTemple'
      this.fireworks='Himeji Castle'
    } else if (lang == 'ko') {
      this.rose = '후지산';
      this.lily = '전쟁';
      this.balloon = '청수사'
      this.fireworks='히메지 성'
    } else {
      this.rose = 'ふじさん';
      this.lily = "せんそうじ";
      this.balloon = 'きよみずでら'
      this.fireworks='ひめじじょう'
    }
    // this.rose = 'A';
    // this.lily = 'B';
    // this.balloon = 'C'
    // this.fireworks='D'
  },
  computed: {
    convertedShopchoose() {
      const mapping = {
        big: this.rose,
        small: this.lily,
        one: this.fireworks,
        two: this.balloon
      };

      return this.shopchoose.split(',').map(keyword => mapping[keyword] || keyword).join(',');
    }
  },
  destroyed() {
    clearInterval(time);
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/css/base.css";
.nav-bar .right {
  padding-left: 8px;
  padding-right: 8px;
  color: #fff;
  font-size: 28px;
  border-radius: 10px;

  line-height: 60px;
}
.lottery {
  position: relative;
  background: url("/img/lotterybg.png") no-repeat
    top;
  background-size: contain;
  font-family: -apple-system, BlinkMacSystemFont, "PingFang SC", "Noto Sans JP",
    "Hiragino Sans", "Yu Gothic", "Microsoft YaHei", sans-serif;
  letter-spacing: 0;
}
.lottery .van-nav-bar {
  background: linear-gradient(
    90deg,
    rgba(223, 53, 173, 0.8),
    rgba(79, 29, 181, 0.8)
  ) !important;
}
.record {
  padding-left: 20px;
  padding-right: 20px;
  background: linear-gradient(
    90deg,
    rgba(223, 53, 173, 0.8),
    rgba(79, 29, 181, 0.8)
  );
  box-shadow: 0 2px 2px 0 #cacaca;
  z-index: 1;
}
.record .period {
  display: flex;
  align-items: center;
  padding: 20px 0;
}
.record .period .cover {
  width: 8vw;
  height: 8vw;
  -o-object-fit: cover;
  object-fit: cover;
}
.record .period .period-number {
  flex: 1;
  margin-left: 20px;
  margin-right: 10px;
  height: 7vw;
  line-height: 7vw;
  font-size: 5vw;
  font-weight: 600;
  color: #fff;
}
.van-count-down {
  color: #f4d70a;
  font-size: 6vw;
  font-weight: 600;
  margin-top: 10px;
  float: right;
}
.linear-gradient {
  width: 100%;
  height: 2px;
  background: linear-gradient(to right, rgba(126, 86, 120, 0), rgb(230, 195, 161), rgba(126, 86, 120, 0));

}
.record .recent {
  display: flex;
  align-items: center;
  height: 110px;
}
.kuaisan-ball .left {
  justify-content: flex-start;
}
.kuaisan-ball {
  flex: 1;
  display: flex;
  align-items: center;
}

.kuaisan-ball .res-img {
  width: 70px;
  height: 70px;
  margin-right: 30px;
}
.kuaisan-ball .res-des {
  font-weight: 700;
  text-align: center;
  color: #000;
}
.kuaisan-ball .res-des.middle {
  width: 15%;
  font-size: 35px;
}
.van-icon {
  font-size: 40px;
}
.down {
  transition: all 0.5s;
}
.up {
  transform: rotate(180deg);
  transition: all 0.5s;
}
.wrapper {
  position: relative;
  flex: 1;
  overflow: hidden;
}
.options-bar {
  display: flex;
  align-items: center;
  height: calc(100% - 11vw);
  background-color: #f2f3f5;
}
.options-bar .game {
  flex: 1;
  height: 100%;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
.options-bar .game .tips {
  display: flex;
  align-items: center;
  height: 100px;
  padding: 0 20px;
}
.options-bar .game .tips .odds {
  flex: 1;
  font-size: 35px;
  font-weight: 500;
  color: #ff253f;
}
.options-bar .game .tips .play-tip {
  display: flex;
  align-items: center;
  height: 100%;
}
::v-deep .van-icon-more-o {
  color: #ff253f;
  font-size: 50px;
}
.options-bar .game .tips .play-tip .span-text {
  margin-left: 10px;
  font-size: 35px;
  font-weight: bolder;
  color: #ff253f;
}
.linear-gradient {
  width: 100%;
  height: 2px;
}
.sumValueTwoSides {
  display: flex;
  padding: 30px 0;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
}
.rectangle {
  overflow: hidden;
}
.rectangle.large {
  width: calc(50% - 7vw) !important;
    height: 21vw !important;
    line-height: 21vw;
    text-align: center;
    background: #fff;
    box-shadow: 0 4px 24px 0 rgba(0, 0, 0, .1);
    margin: 0 0 4vw 4%;
    width: 20%;
    border-radius: 10px;
}
.rectangle .wrapper {
  position: relative;
  padding: 0 10px;
  background: #fff;
}
.rectangle .wrapper .content {
  position: absolute;
  display: flex;
  top: 0;
  left: 0;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}
.rectangle.large .wrapper {
  padding-bottom: 100%;
}
.rectangle .wrapper .content .name-text.large {
  font-size: 4.6vw;
  line-height: 1.2;
}
.rectangle .wrapper .content .name-text {
  color: #7d7c7c;
  font-weight: 400;

}
.rectangle .wrapper .content .odd-text.large {
  font-size: 3vw;
  margin-top: -4vw;
}
.rectangle .wrapper .content .odd-text {
  text-align: center;
  color: #ff253f;
}
.bottom-bar {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 15vw;
  height: 13vw;
  z-index: 2;
}
.bottom-bar .bar .left,
.bottom-bar .bar {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.bottom-bar .bar {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 13vw;
  background-color: #fff;
  box-shadow: 0 0 20px 0 #cacaca;
  z-index: 2;
}
.bottom-bar .bar .left,
.bottom-bar .bar {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.bottom-bar .bar .left .item {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 13vw;
  font-size: 20px;
}
.bottom-bar .bar .left .item .text {
  font-size: 3vw;
  color: #7d7c7c;
}
.jixuanico {
  font-size: 6vw;
}
.bottom-bar .bar .left .line {
  width: 2px;
  height: 7vw;
  background: #dadada;
}
.bottom-bar .bar .mid {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.bottom-bar .bar .mid .text {
  font-size: 4vw;
  font-weight: 500;
  color: #000;
}
.bottom-bar .bar .mid .text.num {
  margin: 0 5px;
  color: #ff253f;
}
.bottom-bar .bar .right {
  padding: 0 4vw;
  margin: 0 4vw;
  color: #fff;
  background: linear-gradient(20deg, #8673e5, #d958a4);
  font-size: 5vw;
  font-weight: 500;
  height: 9vw;
  line-height: 9vw;
  border-radius: 7vw;
}
.rectangle.active .wrapper {
  background-color: #ff253f !important;
}

::v-deep .van-pull-refresh__track .van-pull-refresh__head * {
  color: #000000;
  font-size: 35px;
}
::v-deep .van-popup {
  position: absolute;
}
::v-deep .van-overlay {
  position: absolute;
  background-color: rgb(70 67 67 / 70%);
}
::v-deep .van-popup--top {
  top: -1px;
}
.wrapper .item {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 10px 0;
}
.wrapper .item .left {
  width: 30%;
  font-size: 30px;
  text-align: center;
  font-weight: 500;
  color: #000;
}
.font-weight {
  font-weight: 700 !important;
}
.wrapper .item .right {
  flex: 1;
  display: flex;
  font-size: 30px;
  justify-content: center;
  overflow: hidden;
  color: #000;
}
.wrapper .item .kuaisan-ball .left {
  justify-content: flex-start;
}
.wrapper .item .kuaisan-ball {
  margin-left: 20px;
  flex: 1;
  display: flex;
  align-items: center;
}
.wrapper .item .kuaisan-ball .res-img {
  width: 50px;
  height: 50px;
  margin-right: 20px;
}
.wrapper .item .kuaisan-ball .res-des {
  background: linear-gradient(90deg, #f560cd, #4f2b8a);
    color: #fff;
    height: 7vw;
    line-height: 7vw;
    text-align: center;
    font-size: 3vw;
    font-weight: 700;
    margin-right: 30px;
    width: 7vw;
    border-radius: 50%;
}
.middle{
  border-radius: 16px;
  padding: 0 16px;
  background: linear-gradient(90deg, #f560cd, #4f2b8a);
    color: #fff;
    height: 7vw;
    line-height: 7vw;
    text-align: center;
    font-size: 3vw;
    font-weight: 700;
    margin-right: 30px;
}

.play-type-tip {
  position: unset;
  margin: auto;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 650px;
  height: 700px;
  max-height: 50%;
  z-index: 10;
  border-radius: 30px;
  overflow: hidden;
  background-color: #fff;
  color: #000;
}
.play-type-tip .title {
  line-height: 90px;
  background: linear-gradient(90deg, #7e5678, #e6c3a1);
  text-align: center;
  color: #fff;
  font-size: 35px;
  font-weight: 500;
}
.mask {
  background-color: rgb(0 0 0 / 0%);
  animation-duration: 0.35s;
}
.play-type-tip .wrapper {
  height: calc(100% - 10px);
  background-color: transparent;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
.play-type-tip .wrapper .item {
  padding: 40px 50px;
  display: flex;
  align-items: flex-start;
}
.play-type-tip .wrapper .item .van-icon {
  color: #e6c3a1;
  font-size: 60px;
}
.play-type-tip .wrapper .item .content .content-title {
  margin-top: 22px;
  font-size: 35px;
  font-weight: 500;
  color: #000;
  line-height: 0px;
}
.play-type-tip .wrapper .item .content .content-detail {
  margin-top: 5px;
  font-size: 22px;
  color: #000;
  line-height: 30px;
}
.play-type-tip .wrapper .item .content {
  flex: 1;
  margin-left: 30px;
}
.rectangle.active .wrapper {
  background-color: #d07ac7 !important;
}
.rectangle.active .wrapper .name-text,
.rectangle.active .wrapper .odd-text {
  color: #fff !important;
}
.bottom-bar .wrapper {
  position: absolute;
  top: 10px;
  left: 0;
  right: 0;
  padding: 20px 20px 10px 20px;
  height: 47vw;
  background-color: #fff;
  z-index: 1;
  box-shadow: none;
  transition: transform 0.3s cubic-bezier(0.21, 1.02, 0.55, 1.01);
  box-sizing: border-box;
}
.bottom-bar .wrapper.active {
  transform: translateY(-100%);
}
.bottom-bar .wrapper .item {
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 9vw;
  overflow: hidden;
}
.bottom-bar .wrapper .item .label {
  flex: none;
  font-size: 4vw;
  line-height: 4vw;
  color: #1b0a8a;
  white-space: nowrap;
}
.bottom-bar .wrapper .item .bet-number {
  flex: 1;
  overflow: auto;
  white-space: nowrap;
  -webkit-overflow-scrolling: touch;
  color: #ed37ae;
  font-size: 3vw;
  font-weight: 500;
  height: 5vw;
  line-height: 5vw;
}
.bottom-bar .wrapper .item .count-number,
.bottom-bar .wrapper .item .bet-summary-name {
  color: #ed37ae;
  font-size: 4vw;
  line-height: 4vw;
  white-space: nowrap;
}
.bottom-bar .wrapper .item .count-number {
  margin: 0 4px;
}
.bottom-bar .wrapper .item .bet-summary-name {
  flex: none;
  max-width: none;
  overflow: visible;
  color: #1b0a8a;
}
.bottom-bar .wrapper .item .amount-wrapper {
  flex: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
}
.bottom-bar .wrapper .quick-bet {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 2px 0 0;
}
.bottom-bar .wrapper .quick-bet-item {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  width: 17vw;
  height: 12vw;
  line-height: 11vw;
  color: #a063ee;
  font-size: 4vw;
  font-weight: 500;
  text-align: center;
  background: url("/img/lottery/hua.png") no-repeat center;
  background-size: contain;
  box-sizing: border-box;
}
.bottom-bar .wrapper .quick-bet-item.active {
  color: #fff;
  background: url("/img/lottery/hua_H.png") no-repeat center;
  background-size: contain;
}
.bottom-bar .wrapper .quick-bet-item span {
  display: block;
  width: 100%;
  height: 100%;
  text-align: center;
  line-height: 11vw;
}
.van-cell {
  font-size: 4vw;
  line-height: 7vw;
}
.bottom-bar .wrapper .item .part {
  margin-right: 20px;
}
.bottom-bar .wrapper .item .part span {
  font-size: 30px;
  vertical-align: center;
  color: #000;
}
.bottom-bar .wrapper .item .part .number {
  margin: 0 5px;
  color: #ff253f;
  font-weight: 500;
}
::v-deep .van-field__control {
  color: #1b0a8a;
}
::v-deep .van-field__control::placeholder {
  color: #c8c9cc;
}
::v-deep .amount-wrapper .van-cell {
  background-color: #f2f2f5;
  padding: 0 16px;
}
::v-deep .amount-wrapper .van-field__body {
  height: 9vw;
}
.confirm-order-modal {
  position: unset;
  display: flex;
  flex-direction: column;
  margin: auto;
  padding: 0 20px 30px;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 610px;
  height: 680px;
  max-height: 50%;
  z-index: 10;
  background-color: #fff;
  border-radius: 30px;
}
.confirm-order-modal .head {
  position: relative;
  height: 80px;
}
.confirm-order-modal .head .text {
  padding: 0 20px;
  height: 30px;
  line-height: 10px;
  text-align: center;
  font-size: 35px;
  font-weight: 400;
  color: #7e5678;
}
::v-deep .confirm-order-modal .van-hairline--bottom::after {
  border-bottom-width: 2px;
}
.van-popup--center {
  border-radius: 30px;
}
.confirm-order-modal .list {
  flex: 1;
  padding: 0 10px;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
.confirm-order-modal .list .lise-item {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 10px 0;
}
.confirm-order-modal .list .lise-item .main {
  flex: 1;
  overflow: hidden;
}
.confirm-order-modal .list .lise-item .main .bet-name {
  color: #ff253f;
  font-size: 35px;
  font-weight: 400;
  line-height: 0px;
  word-wrap: break-word;
  word-break: break-all;
}
.confirm-order-modal .list .lise-item .main .detail-text {
  line-height: 0px;
  font-size: 25px;
  color: #979799;
}
.confirm-order-modal .list .lise-item {
  color: #ff253f;
}
.confirm-order-modal .sub-bar {
  display: flex;
  align-items: center;
  margin-top: 30px;
  justify-content: space-around;
}
.confirm-order-modal .sub-bar .item {
  min-width: 40%;
  height: 80px;
  text-align: center;
  box-sizing: border-box;
  border-radius: 50px;
  font-size: 35px;
  font-weight: 500;
}
.confirm-order-modal .sub-bar .item.cancel-btn {
  border: 2px solid #979799;
  color: #979799;
  background-color: #fff;
}
.confirm-order-modal .sub-bar .item.sub-btn {
  background: linear-gradient(20deg, #8673e5, #d958a4);
  color: #fff;
  border: 0;
}
.next-number span {
  font-size: 35px;
  font-weight: 700;
  color: #000;
  float: right;
}
.numberBox .resBox{
  display: flex;
    align-items: center;
    background: #fff;
    border-radius: 16px;
    padding: 16px;
    height: 100%;
    margin-left: 10px;
    width: calc(100% - 37vw);
    box-sizing: border-box;
}
.resBox .resItem{
  width: 9vw;
    height: 9vw;
    line-height: 9vw;
    margin-right: 20px;
    background: linear-gradient(90deg, #8b73e6, #d75db4);
    border-radius: 50%;
    color: #fff;
    text-align: center
}
.ressquareBox{
  border-radius: 16px;
  padding: 0 16px;
  background: linear-gradient(90deg, #f560cd, #4f2b8a);
    color: #fff;
    height: 7vw;
    line-height: 7vw;
    text-align: center;
    font-size: 3vw;
    font-weight: 700;
}
.ballBox{
  color: #d75db4;
    font-weight: 700;
    margin-right: 8px;
    font-size: 5vw;
}
.list{
 padding: 4vw;
}
.list .item{
  background-color: #e4e4e7;
  border-radius: 16px;
  padding: 40px;
  margin-bottom: 20px;
}
</style>
